export default __webpack_public_path__ + "static/media/background.44aa9690.jpg";